export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "审核部门详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "审核部门名称：",
            type: "input",
            value: "departmentName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写审核部门名称",
              trigger: "blur"
            }
          },
          {
            label: "审核部门编号：",
            type: "input",
            value: "departmentCode",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写审核部门编号",
              trigger: "blur"
            }
          },
          {
            label: "行政区划：",
            type: "select",
            value: "areaCode",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/AreaCodeDataCombobox",
              flag: "0"
            },
            rule: {
              required: true,
              message: "请选择行政区划",
              trigger: "blur"
            }
          },
          {
            label: "备注：",
            value: "remark",
            type: "textarea",
            required: true,
            maxlength: 1000,
            minRows: "3",
            maxRows: "2",
            width: "100%;"
          }
        ]
      }
    ];
  }
}
